import { Injectable } from "@angular/core";
import { FetchHelper } from "../../core/helpers/fetch-helper";
import { Constant } from "../../core/configs/constant";
import { Router } from "@angular/router";
import { AppConfigService } from "./app-config.service";
import { CategoriesTypeService } from "./categories-type.service";
import { BehaviorSubject, Subject } from "rxjs";
import { TableDynamicService } from "./table-dynamic.service";


enum PERMISSION {
  READ = "READ",
  ADD = "ADD",
  EDIT = "EDIT",
  DELETE = "DELETE",
  IMPORT = "IMPORT",
  EXPORT = "EXPORT",
  DOWNLOAD = "DOWNLOAD"
}

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  moduleParent = [];
  modulesSSO = [];
  public currentRoleName: any;
  public subModulePath: any[] = [];
  private menuChanged = new BehaviorSubject<boolean>(false);
  menuChanged$ = this.menuChanged.asObservable();
  private loginSuccessSubject = new Subject<void>();
  public loginSuccess$ = this.loginSuccessSubject.asObservable();

  constructor(
    private router: Router,
    private categoriesTypeService: CategoriesTypeService,
    private tableDynamicService: TableDynamicService
  ) {
  }

  async verifyCode(email: any, code: any) {
    return await FetchHelper.post(Constant.FORGOT_PASSWORD.VERIFY_CODE, { email, code })
  }

  async resetPassword(email: any, code: any, newPassword: any) {
    return await FetchHelper.post(Constant.FORGOT_PASSWORD.RESET_PASSWORD, { email, code, newPassword })
  }

  async changePassword(data: any) {
    return await FetchHelper.post(Constant.FORGOT_PASSWORD.CHANGE_PASSWORD, data )
  }

  async checkEmail(emailOrName: any) {
    return await FetchHelper.post(Constant.FORGOT_PASSWORD.CHECK_EMAIL, { emailOrName })
  }

  async login(userName: string, password: string) {
    return await FetchHelper.post(Constant.AUTHEN.LOGIN, { userName, password })
  }

  async ssoLogin(ticket: string) {
    return await FetchHelper.post(Constant.AUTHEN.SSO_LOGIN + `?ticket=${encodeURIComponent(ticket)}`, { ticket })
  }

  redirectToSso() {
    if (typeof window === 'undefined') return;
    const config = this.getSsoConfig();
    if (config.enabled) {
      window.location.href = this.buildSsoUrl(config.loginUrl, config.appCode);
    }
  }

  getSsoConfig() {
    return {
      enabled: Constant.SSO.ENABLED,
      appCode: Constant.SSO.APP_CODE,
      loginUrl: Constant.SSO.LOGIN_URL,
      logoutUrl: Constant.SSO.LOGOUT_URL
    };
  }

  buildSsoUrl(baseUrl: string, appCode: string): string {
    const redirectUrl = `${window.location.origin}/#/sso-login`;
    const separator = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${separator}appCode=${encodeURIComponent(appCode)}&redirectUrl=${encodeURIComponent(redirectUrl)}`;
  }

  notifyLoginSuccess() {
    this.loginSuccessSubject.next();
  }

  logout() {
    localStorage.clear();
    if (AppConfigService.settings?.casAuthentication) {
      window.location.href = Constant.AUTHEN.LOGOUT;
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  checkModulePermission(routePath: string, permission?: PERMISSION): boolean {
    const modules = this.getModules()

    if (modules) {
      this.getRouterPath(JSON.parse(modules))
      const pathSet = new Set(this.subModulePath.map((item) => item.routerPath));
      const permissions = this.subModulePath.find(m => m.routerPath === routePath)?.permissions
      if (permission) {
        return pathSet.has(routePath) && permissions.includes(permission);
      }
      return pathSet.has(routePath)
    }
    return true
  }

  getPermissions(routePath: string): string[] {
    const modules = this.getModules()
    if (modules) {
      this.getRouterPath(JSON.parse(modules))
      const permissions = this.subModulePath.find(m => m.routerPath === routePath)?.permissions
      return permissions
    }
    return []
  }

  getModules() {
    return localStorage.getItem('modules');
  }

  getModuleAll() {
    return localStorage.getItem('moduleAll');
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem('token');
  }

  async setModule(modulesOfUser: string, moduleAll: any[]) {
    this.moduleParent = [];

    localStorage.setItem('moduleAll', JSON.stringify(moduleAll || []));
    this.menuChanged.next(true);

    if (modulesOfUser && modulesOfUser !== 'undefined' && modulesOfUser !== 'null') {
      try {
        const parsed = JSON.parse(modulesOfUser);
        if (Array.isArray(parsed) && parsed.length > 0) {
          localStorage.setItem('modules', modulesOfUser);
          this.getAllCurrentRouterPath(parsed);
          return;
        }
      } catch {}
    }

    localStorage.setItem('modules', JSON.stringify(moduleAll || []));
    this.getAllCurrentRouterPath(moduleAll || []);
  }


  getAllCurrentRouterPath(modules: any[]) {
    this.subModulePath = [];
    this.getRouterPath(modules || []);
    this.setLocalSubModulePath(this.subModulePath);
  }

  getRouterPath(modules: any[]) {
    if (!modules || !Array.isArray(modules)) return;
    modules.forEach(
      x => {
        if (x && x.routerPath && x.routerPath != '') {
          this.subModulePath.push(x);
        }
        if (x && x.subModules && x.subModules.length > 0) {
          this.getRouterPath(x.subModules);
        }
      }
    );
  }

  setLocalSubModulePath(path: any[]) {
    return localStorage.setItem('subModulePath', JSON.stringify(path));
  }

  setToken(tokenValue: string) {
    localStorage.setItem('token', tokenValue);
  }

  getToken() {
    return localStorage.getItem('token');
  }

  setUserInfo(userInfo: string) {
    localStorage.setItem('userInfo', userInfo);
  }

  getUserInfo() {
    return localStorage.getItem('userInfo');
  }

  getTimeCheck() {
    return localStorage.getItem('time_check');
  }

  setTimeCheck(time_check: any) {
    localStorage.setItem('time_check', time_check);
  }

}
